


























































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  modalErrorStore,
  modalReturnHistoryStore
} from '@/utils/store-accessor'
import { NAV_LOADING_END, NAV_LOADING_START } from '@/config/event'
import {
  AlertMessage,
  collectionApi,
  ErrorMessage,
  ReturnHistory,
  SystemCode
} from '@/api'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { SortOrder } from '@/types'
import { orderBy } from 'lodash'

const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '34',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'userId',
        headerText: '利用者番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '33',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'returnTime',
        headerText: '返却日時',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '33',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'returnBranchCode',
        headerText: '返却館',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    ModalFooter
  }
})
export default class ModalReturnHistory extends ModalComponentBaseVue {
  returnHistories: ReturnHistory[] = []

  sortName: string = ''

  sortOrder: SortOrder = ''

  tableBodyHeight: number = 0

  get sortedReturnHistories(): ReturnHistory[] {
    if (this.sortName) {
      return orderBy<ReturnHistory>(
        this.returnHistories,
        (item: ReturnHistory) => {
          const propertyValue = item[this.sortName as keyof ReturnHistory]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.returnHistories
  }

  get collectionNo(): string {
    return modalReturnHistoryStore.collectionNo
  }

  get collectionId(): number {
    return modalReturnHistoryStore.collectionId
  }

  get isOpen(): boolean {
    return modalReturnHistoryStore.isOpen
  }

  get cols(): Col[] {
    return COLS
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      this.getReturnHistory()
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
        this.calculateTableHeight()
      })
    }

    this.returnHistories = []
    this.onSort({
      name: '',
      order: ''
    })
    window.removeEventListener('resize', this.onResize)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onClickOk(): void {
    modalReturnHistoryStore.close()
  }

  onClickLink(userId: string): void {
    modalReturnHistoryStore.link(userId)
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-return-history')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  async getReturnHistory(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.returnHistories = await collectionApi.getReturnHistories(
        this.collectionId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      modalReturnHistoryStore.close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
